module.exports = __webpack_public_path__ + "img/HT-logo-tight-black.08a974d5.png";